import { FormEvent, useContext, useEffect, useState } from "react";
import { Modal, Form, Select, Button, Typography } from "antd";
import { useParams } from "react-router-dom";
import { MenuItem, TextField } from "@mui/material";
import { BanksModel } from "../../../Models/BanksModel";
import { GetAllBanks } from "../../../API/BanksAPI";
import { CreateRegister } from "../../../API/RegisterAPI";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext";
import Loader from "../../Shared/Loader";
import { ProjectGroupingModel } from "../../../Models/ProjectGroupingModel";
import { CreatePleaAPI, GetAllProjectGroupingByCompany } from "../../../API/PleaAPI";
import "./styles.css";

const { Title } = Typography;

interface CreatePleaModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    getAllPlea: () => void;
}

export const CreatePleaModal = ({ showModal, setShowModal, getAllPlea }: CreatePleaModalProps) => {
    const { userEmail } = useContext(AuthContext);
    const [projectGrouping, setProjectGroupings] = useState<ProjectGroupingModel[]>([]);
    const { id } = useParams();
    const [banks, setBanks] = useState<BanksModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();


    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        getProjectGroupings();
        GetAllBanks()
            .then(response => setBanks(response.data));

    }, []);

    async function getProjectGroupings() {
        try {
            setLoading(true);
            await GetAllProjectGroupingByCompany(id ?? "").then((resp: any) => {
                setProjectGroupings(resp.data);
            });
        }
        catch (error: any) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    }

    function submitRegisterForm(values: any) {
        setLoading(true);

        const projectGroupingId = values.panel;
        const bankName = values.bank;

        CreatePleaAPI(id ?? "", projectGroupingId, bankName, userEmail)
            .then(response => {
                toast.success('Pleito criado com sucesso!');
                setShowModal(false);
                setLoading(false);
                getAllPlea();
                form.resetFields();
            })
            .catch(err => {
                toast.error(err);
                setLoading(false);
            });
    }

    return (
        <>
            <div >
                {loading && <Loader />}
                <Modal
                    className="create-plea-modal"
                    title="Informações iniciais"
                    open={showModal}
                    onCancel={handleCloseModal}
                    footer={null}
                >
                    {loading && <Loader />}
                    <Form form={form} layout="vertical" onFinish={submitRegisterForm}>
                        <Form.Item
                            label="Selecione o Banco de Fomento:"
                            name="bank"
                            rules={[{ required: true, message: "Por favor, selecione um Banco!" }]}
                            validateTrigger={["onBlur", "onSubmit"]}
                        >
                            <Select placeholder="Selecione..." allowClear>
                                {banks.map(bank => (
                                    <Select.Option key={bank.id} value={bank.name}>{bank.name}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Selecione o Agrupamento de Projetos:"
                            name="panel"
                            rules={[{ required: true, message: "Por favor, selecione um agrupamento!" }]}
                            validateTrigger={["onBlur", "onSubmit"]}
                        >
                            <Select placeholder="Selecione..." allowClear>
                                {projectGrouping.map(grouping => (
                                    <Select.Option key={grouping.id} value={grouping.id}>{grouping.name} - {grouping.year}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <div className="modal-buttons">
                            <Button onClick={handleCloseModal}>Cancelar</Button>
                            <Button type="primary" htmlType="submit">Continuar</Button>
                        </div>
                    </Form>
                </Modal>
            </div>
        </>
    );
}